import React from 'react'

const Manual_inventario_ingredientes = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
          Inventario - Ingredientes
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          La guía explica cómo añadir nuevos ingredientes al inventario, asegurando un registro detallado y un control eficiente de existencias. También ayuda a mejorar la relación con proveedores y optimizar la gestión del inventario.
        </p>
        <iframe
          src="https://scribehow.com/embed/Inventario__Ingredientes__rDpQHi_YSx-84xpVhp6oAA?as=scrollable"
          className="scribe-iframe-general-44"
          width="100%"
          height="3750"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_inventario_ingredientes